// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".root__QOFVuEegQq{display:inline-flex;align-items:center;gap:10px}", "",{"version":3,"sources":["webpack://./src/assets/components/settings/components/sections/dixaMessenger/views/appearance/components/setup/components/documentationLink/documentationLink.module.scss"],"names":[],"mappings":"AAAA,kBACE,mBAAA,CACA,kBAAA,CACA,QAAA","sourcesContent":[".root {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "root__QOFVuEegQq"
};
export default ___CSS_LOADER_EXPORT___;
